<template>
  <nav class="navbar">
    <p class="navbar__title title title--3">{{ $t('navbar.title') }}</p>

    <div class="navbar__section">
      <p class="navbar__section__title">
        {{ $t('navbar.estimations.title') }}
      </p>

      <router-link
        class="navbar__section__button"
        :to="{ name: 'pending-estimations' }"
      >
        <span class="special-icon">
          <i class="fas fa-thumbs-up"></i>
          <i class="fas fa-thumbs-down"></i>
        </span>

        <span>{{ $t('navbar.estimations.pending') }}</span>
      </router-link>

      <router-link
        class="navbar__section__button"
        :to="{ name: 'sent-estimations' }"
      >
        <i class="fas fa-check"></i>

        <span>{{ $t('navbar.estimations.sent') }}</span>
      </router-link>

      <router-link
        class="navbar__section__button"
        :to="{ name: 'rejected-estimations' }"
      >
        <i class="fas fa-times-circle"></i>

        <span>{{ $t('navbar.estimations.rejected') }}</span>
      </router-link>

      <router-link
        class="navbar__section__button"
        :to="{ name: 'outdated-estimations' }"
      >
        <i class="fas fa-thumbs-down"></i>

        <span>{{ $t('navbar.estimations.outdated') }}</span>
      </router-link>

      <button
        v-if="isAdmin"
        class="navbar__section__button"
        @click="downloadEstimations"
      >
        <i class="fas fa-file-download"></i>
        <span>{{ $t('navbar.estimations.export') }}</span>
      </button>
    </div>

    <div class="navbar__section">
      <p class="navbar__section__title">
        {{ $t('navbar.transactions.title') }}
      </p>

      <router-link
        class="navbar__section__button"
        :to="{ name: 'pending-transactions' }"
      >
        <i class="fas fa-clipboard-list"></i>

        <span>{{ $t('navbar.transactions.pending_transactions') }}</span>
      </router-link>

      <router-link
        class="navbar__section__button"
        :to="{ name: 'validated-transactions' }"
      >
        <i class="fas fa-shopping-cart"></i>

        <span>{{ $t('navbar.transactions.validated_transactions') }}</span>
      </router-link>
    </div>

    <div class="navbar__section">
      <p class="navbar__section__title">
        {{ $t('navbar.clients.title') }}
      </p>

      <router-link class="navbar__section__button" :to="{ name: 'clients' }">
        <i class="fas fa-users"></i>

        <span>{{ $t('navbar.clients.clients') }}</span>
      </router-link>
    </div>

    <div class="navbar__section">
      <p class="navbar__section__title">
        {{ $t('navbar.settings.title') }}
      </p>

      <button class="navbar__section__button" @click.prevent="userLogout">
        <i class="fas fa-arrow-right"></i>

        <span>{{ $t('navbar.settings.logout') }}</span>
      </button>
    </div>
  </nav>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { api } from '../lib/api';

export default {
  computed: {
    ...mapGetters({
      isAdmin: 'user/isAdmin',
    }),
  },

  methods: {
    ...mapActions({
      logout: 'user/logout',
      setLoading: 'app/setLoading',
      setToaster: 'app/setToaster',
    }),
    userLogout() {
      this.logout();

      this.$router.push('/login');
    },
    async downloadEstimations() {
      this.setLoading({ value: true, message: 'loading-export' });

      try {
        const response = await api.get('/api/estimations/export.csv', {
          headers: {
            Accept: 'text/csv',
          },
        });

        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
        const fileLink = document.createElement('a');

        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'estimations.csv');
        document.body.appendChild(fileLink);
        fileLink.click();
      } catch {
        this.setToaster([
          {
            error: 'errors.estimation.export',
            time: Date.now(),
          },
        ]);
      }

      this.setLoading({ value: false });
    },
  },
};
</script>

<style lang="scss" scoped>
.special-icon {
  font-size: 70%;
  margin-right: 28px;

  .fa-thumbs-up {
    margin-right: 0;
    position: relative;
    top: -3px;
  }
  .fa-thumbs-down {
    margin-right: 0;
    position: relative;
    top: 3px;
    transform: scaleX(-1);
  }
}
</style>
